/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*@author :Sanjana Shende
 *@fileName :AddUserAdvertiser.js
 *Desc: Add User
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { withRouter } from "react-router-dom";
import Footer from "../layouts/footer";
import Navigation from "../layouts/navPage";
import { Tooltip,Table,Icon,Radio } from "antd"; //Aman-4749-(removed 'Form,Input,Cascader,Select,Row,Col,Checkbox,Button,AutoComplete,Card,'  not in use)-Console Warnings - Advertiser - Settings //5761-Removed unused Input
import { css } from "emotion"; //Sandeep-task-3447-added css file
import "./addUserAdvertiser.css"; //Sandeep-task-3447-added css file
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; // karan-task-3723-vapt header and query params
import Picky from "react-picky"; //Anshul-5726: added for advertiser list
const Swal = require("sweetalert2");
const tableCSS = css({
	backgroundColor: "white",
	margin: "10px", //Anshul-5726: added margin for table
	boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px", //Anshul-5780
	"& thead > tr > th": {
		backgroundColor: "#144999", //rutuja task -4524 changed background color
		color: "white",
		fontWeight: "500",
		// wordWrap:"break-word",
		// width:'10%'
		
	},
	"& thead > tr": {
		borderWidth: "2px",
		borderStyle: "solid",
	},
}); //Sandeep-task-3447-added css file

class AddUserAdvertiser extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			inputClass11: "btn add-button",
			fields: {},
			errors: "",
			loader2: "",
			userDomain: "",
			tableSearchText: "",	//Priyanka-5456-added to store value for search
      		userDetailsSearch: [],	//Priyanka-5456-added search data array
		    filterStatus: "activeUsers", //Anshul-5726: for storing active or deactivated radio button value
            activatedUsersCheckboxArray: [], //Anshul-5726: added to store the active users
            deactivatedUsersCheckboxArray: [], //Anshul-5726: added to store the deactivated users
            showAdvertiserMovePopup: false, //Anshul-5726: added move popup initially set as false
      
          
             disableSaveButton: true, //Anshul-5726: disabled Save button until all input values are not filled
              selectedAdvertiser: [], // Anshul-5726: stores selected advertiser from the select advertiser dropdown
		};
		this.handleChange = this.handleChange.bind(this);
		this.submitUser = this.submitUser.bind(this);
		this.handleChangeSearch = this.handleChangeSearch.bind(this);	//Priyanka-5456-added search function binding 
  this.handleMoveButtonClick = this.handleMoveButtonClick.bind(this); //Anshul-5726
    this.handleClosePopup = this.handleClosePopup.bind(this); //Anshul-5726
	} // end of constructor
	componentDidMount() {
		//Aman-4749-(commented not in use)-Console Warnings - Advertiser - Settings
		//var parsed=this.props.location.state;//kiran- task 3867- VAPT-Advertiser side-adv dashboard and specification -URL links & API -FE
		const { user } = this.props.auth; //Aman-4749-(commented isAuthenticated - not in use)-Console Warnings - Advertiser - Settings
		//var advertiserID=user.id;//kiran- task 3867- VAPT-Advertiser side-adv dashboard and specification -URL links & API -FE

		var userName = user.name;
		userName = userName.split("@");
		var userName1 = "@" + userName[1];
		this.setState({ userDomain: userName1 });
		/* @author Sandeep Dhawale
		 * @param  Description get user details
		 * @return Description get user details
		 */
		this.setState({ loader2: "loader_report1" });
		fetch("/users/getUserList", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
		}) // karan-task-3723-vapt header and query params
			.then((res) => res.json())
			.then((getUserList) => {
				this.setState({ getUserList: getUserList, loader2: "" });
			})
			.catch(function (err) {
				console.log(err);
			});
	}

	validateForm() {
		let fields = this.state.fields;
		let errors = {};
		let formIsValid = true;
		let spanDisplay = "none";
		let requiredFeildValidate = "true";
		let userNameValidate = "true";
		let firstNameValidate = "true";
		let lastNameValidate = "true";
		let roleValidate = "true";

		fields["userName"] = fields["userName"] + this.state.userDomain;
		this.setState({ fields });

		if (
			!fields["userName"] &&
			!fields["role"] &&
			!fields["firstName"] &&
			!fields["lastName"]
		) {
			requiredFeildValidate = false;
			errors["commonError"] = <li>Please fill below required fields</li>;
			this.setState({ errors: errors });
		} else {
			if (
				this.state.userName === "" ||
				this.state.userName == null ||
				this.state.userName === undefined
			) {
				userNameValidate = false;

				errors["userName"] = <li>Please enter user name</li>;
				this.setState({ errors: errors });
			} else {
				//shivani - 3599 - changed RegEx as per validation requirement for hyphen .
				//  var pattern = new RegExp(/^([a-zA-Z]+[\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,3}(?:\.[a-z]{2})?)$/)
				//sunita-task-3782-changed below condition as per requirement
				//Sandeep-task-3893-Production issue-Email format issue--All roles
				var pattern = new RegExp(
					// /^\s*$|^[a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/)
					// eslint-disable-next-line no-useless-escape
					/^\s*$|^[\.a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@(?!gmail.com)(?!gmail.co.in)(?!yahoo.com)(?!yahoo.co.in)(?!facebook.com)(?!facebook.co.in)[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/
				);//mufiz 4091
			// 	if (!pattern.test(fields["userName"])) {
			// 		userNameValidate = false;
			// 		errors["userName"] = <li>Please enter valid user name</li>;
			// 		this.setState({ errors: errors });
			// 	} else {
			// 		errors["userName"] = "";
			// 		this.setState({ errors: errors });
			// 	}
			// }
		     // 5778-Kiran Dhainje -commented This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting

		// 	if (this.state.userName.match(pattern)) {  // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
		// 		userNameValidate = true;   
		// 		// errors["userName"] = 
		// 		// this.setState({ errors: errors });
		// 	} else  {
		// 		userNameValidate = false;
		// 		errors["userName"] = <li>Please enter valid user name</li>;
		// 		this.setState({ errors: errors });
		// 	}// mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
		// }


		// Added the confition for this 5778-Kiran Dhainje- This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting
		 if (!this.state.userName || /^\s*$/.test(this.state.userName)) {
            userNameValidate = false;
            errors["userName"] = <li>User name cannot be blank or spaces</li>;
          this.setState({ errors: errors });
        } else if (this.state.userName.match(pattern)) {
               // existing email regex check
                userNameValidate = true;
               } else {
               userNameValidate = false;
               errors["userName"] = <li>Please enter valid user name</li>;
                      this.setState({ errors: errors });
                   }
      }
			//Aman-4749-(added '===' and instead saw '==')-Console Warnings - Advertiser - Settings
			if (
				this.state.firstName === "" ||
				this.state.firstName === null ||
				this.state.firstName === undefined
			) {
				firstNameValidate = false;
				errors["firstName"] = <li>Please enter first name</li>;
				this.setState({ errors: errors });
			} else {
				let pattern = new RegExp(/^[a-zA-Z]+$/); //Aman-4749-(change var to let to resolve duplicate var issue)-Console Warnings - Advertiser - Settings
				if (!pattern.test(fields["firstName"])) {
					userNameValidate = false;
					errors["firstName"] = <li>Please enter valid first name</li>;
					this.setState({ errors: errors });
				} else {
					errors["firstName"] = "";
					this.setState({ errors: errors });
				}
			}
			//Aman-4749-(added '===' and instead saw '==')-Console Warnings - Advertiser - Settings
			if (
				this.state.lastName === "" ||
				this.state.lastName === null ||
				this.state.lastName === undefined
			) {
				lastNameValidate = false;
				errors["lastName"] = <li>Please enter last name</li>;
				this.setState({ errors: errors });
			} else {
				let pattern = new RegExp(/^[a-zA-Z]+$/); //Aman-4749-(change var to let to resolve duplicate var issue)-Console Warnings - Advertiser - Settings
				if (!pattern.test(fields["lastName"])) {
					userNameValidate = false;
					errors["lastName"] = <li>Please enter valid last name</li>; //Sandeep-task-2909-added code for validation message
					this.setState({ errors: errors });
				} else {
					errors["lastName"] = "";
					this.setState({ errors: errors });
				}
			}
			//Aman-4749-(added '===' and instead saw '==')-Console Warnings - Advertiser - Settings
			if (
				this.state.role === "" ||
				this.state.role === null ||
				this.state.role === undefined
			) {
				roleValidate = false;
				errors["role"] = <li>Please enter role</li>;
				this.setState({ errors: errors });
			} else {
				errors["role"] = "";
				this.setState({ errors: errors });
			}
		}
		//Aman-4749-(added '===' and instead saw '==')-Console Warnings - Advertiser - Settings
		if (
			requiredFeildValidate === false ||
			userNameValidate === false ||
			firstNameValidate === false ||
			lastNameValidate === false ||
			roleValidate === false
		) {
			formIsValid = false;
			this.setState({
				errors: errors,
				alertBorder: "1px solid red",
				alertWidth: "1000px",
				alertAlign: "center",
				alertDisplay: "block",
				spanSpaceDisplay: spanDisplay,
			});
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		} else if 
		(requiredFeildValidate === true ||  //// mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip //Aman-4749-(added '===' and instead saw '==')-Console Warnings - Advertiser - Settings
			userNameValidate === true   ||
			firstNameValidate === true  ||
			lastNameValidate === true   ||
			roleValidate === true) 
			{
			formIsValid = true;
			// alert("success");
		    }
		return formIsValid;
	}


	// handleChange(e) {
	// 	let fields = this.state;

	// 	fields[e.target.name] = e.target.value;
	// 	this.setState({ fields });
	// }

	// Anshul-5726: updated handleChange to enable/disable the save button

	 handleChange(e) {
    // Anshul-5781: updated state
    let fields = this.state.fields;
    const { name, value } = e.target;
     fields[name] = value;
const { userName, firstName, lastName, role } = fields;
  this.setState(
    { 
      fields,
      [name]: value }, 
    () => {
    //  const { userName, firstName, lastName, role } = this.state;
      const allFilled = userName && firstName && lastName && role && role !== "None Selected";

      this.setState({ disableSaveButton: !allFilled });
    }
  );
}


	submitUser(e) {
		//const { isAuthenticated, user } = this.props.auth; //Aman-4749-(commented not in use)-Console Warnings - Advertiser - Settings
		let data = {
			//  userName:this.state.userName+this.state.userDomain,
			//sunita-task-3782-userName send to BE which user will enter
			userName: this.state.userName, 
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			role: this.state.role,
		}; // karan-task-3723-vapt header and query params

		if (this.validateForm() === false) {
			return;
		} else {
     // const self = this;//snehal-task-3768-vAPT URL changes //Aman-4749-(commented not in use)-Console Warnings - Advertiser - Settings
			let errors = {};
			fetch("/users/addUserDetails", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(data),
			})
				.then((res) => res.json())
				.then((userDetails) => {
					if (userDetails.length > 0) {
						errors["sameUser"] = <li>User Already Exists</li>;
						this.setState({ errors: errors });
					} else {
						fetch("/users/addUser", {
							method: "POST",
							headers: { "Content-Type": "application/json" },
							body: JSON.stringify(data),
						})
							.then(function (response) {
								if (response.status >= 400) {
									throw new Error("Bad response from server");
								}
								return response.json();
							})
							.then(function (response) {
								// success message with response
								//Aman-4749-(added '===' and instead saw '==')-Console Warnings - Advertiser - Settings
								if (response.success === true) {
									Swal.fire({
										text: "User Added Successfully",
										type: "success",
										confirmButtonText: "Ok",
										allowOutsideClick: false,
										preConfirm: () => {
                    //   self.props.history.push("/advertiserDashboard",{advertiserID:user.id})//snehal-task-3768-vAPT URL changes
				
						window.location.reload(); //Mufiz-3975-added code for refreshing the page.
					
                    }
									});
								} else {
								}
							});
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		}
	}
	 //Rutuja-5101-Added function for active status
	// changeUserStatusActive(e, record) {
	// 	var orgID = record.userID;
	// 	//Priyanka-5438-Passing role
	// 	var role = record.role;
	// 	let data = {
	// 	  orgID: orgID,
	// 	  role:role,
	// 	  userName : record.userName  //Priyanka-5468-Passing selected username to BE
	// 	};
	// 	fetch("/users/setUserStatusActiveDIQA", {
	// 	  method: "POST",
	// 	  headers: { "Content-Type": "application/json" },
	// 	  body: JSON.stringify(data),
	// 	})
	// 	  .then((res) => res.json())
	// 	  .then((response) => {
	// 		if (response.success === true) {
	// 		  Swal.fire({
	// 			text: "User Activated",
	// 			type: "success",
	// 			confirmButtonText: "Ok",
	// 			allowOutsideClick: false,
	// 			preConfirm: () => {
	// 			  window.location.reload();
	// 			},
	// 		  });
	// 		}
	// 		else{
	// 			//Priyanka-5468-Showing error message
	// 			Swal.fire({
	// 			  text: "User Already exists",
	// 			  type: "error",
	// 			  confirmButtonText: "Ok",
	// 			  allowOutsideClick: false,
	// 			  preConfirm: () => {
	// 				window.location.reload();
	// 			  },
	// 			});
	// 		  }
	// 		this.setState({ isDisabled: true });
	// 	  });
	//   }

	// Anshul-5726: updated above code to send multiple advertisers 
	 changeUserStatusActive() {
      const { deactivatedUsersCheckboxArray } = this.state;
  
      if (
        !Array.isArray(deactivatedUsersCheckboxArray) ||
        deactivatedUsersCheckboxArray.length === 0
      ) {
        console.error("No active users selected for deactivation.");
        return;
      }
  
      const data = deactivatedUsersCheckboxArray.map((u) => ({ userID: u.userID }));
     
      fetch("/users/setUserStatusActiveDIQA", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success === true) {
            Swal.fire({
              text: "User Activated",
              type: "success",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          } else {
            Swal.fire({
              text: "Some users could not be Activated.",
              type: "error",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          }
          this.setState({ isDisabled: true });
        })
        .catch((error) => {
          console.error("Error in deactivation request:", error);
        });
    }




//Rutuja-5101-Added function for Inactive status
	// changeUserStatusInactive(e,record) {
	// 	// const {name, value } = e.target; //Nilesh-2897-Removing console warnings
	// 	// var orgID = record.userID
	// 	var userID = record.userID
	// 	  let data={
	// 		userID:userID,
	// 	  }
	// 	  fetch("/users/setUserStatusInactivePub", {
	// 		  method: "POST",
	// 		  headers: { "Content-Type": "application/json" },
	// 		  body: JSON.stringify(data),
	// 	  })
	// 		  .then((res) => res.json())
	// 		  .then((response) => {
	// 			  if (response.success === true) {
	// 				  Swal.fire({
	// 					  text: "User Deactivated",
	// 					  type: "success",
	// 					  confirmButtonText: "Ok",
	// 					  allowOutsideClick: false,
	// 					  preConfirm: () => {
	// 						   window.location.reload();
	// 					  },
	// 				  });
	// 			  }
	// 			  this.setState({isDisabled: true,})
	// 		  });
	//   }

		// Anshul-5726: updated above code to send multiple advertisers in BE
	  changeUserStatusInactive() {
		const { activatedUsersCheckboxArray } = this.state;
	
		if (
		  !Array.isArray(activatedUsersCheckboxArray) ||
		  activatedUsersCheckboxArray.length === 0
		) {
		  console.error("No active users selected for deactivation.");
		  return;
		}
	
  const data = activatedUsersCheckboxArray.map((u) => ({ userID: u.userID }));
	
		fetch("/users/setUserStatusInactivePub", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify(data),
		})
		  .then((res) => res.json())
		  .then((response) => {
			if (response.success === true) {
			  Swal.fire({
				text: "User Deactivated",
				type: "success",
				confirmButtonText: "Ok",
				allowOutsideClick: false,
				preConfirm: () => {
				  window.location.reload();
				},
			  });
			} else {
			  Swal.fire({
				text: "Some users could not be deactivated.",
				type: "error",
				confirmButtonText: "Ok",
				allowOutsideClick: false,
			  });
			}
	
			this.setState({ isDisabled: true });
		  });
	  }

	//Priyanka-5456-added handleChangeSearch to Search user by firstName,lastName email & role
	handleChangeSearch(e) {
		e.preventDefault();
		let currentList = [];
		// Variable to hold the filtered list before putting into state
		let newList = [];
		let filterData = e.target.value;
	
		this.setState({filterData})//snehal-task-3574-advertiser side--my report-- filter issue
		// If the search bar isn't empty
		if (e.target.value.toString() === "") { //kiran-2836-Removing console warnings
		  newList = this.state.getUserList;
		} else {
		  // Assign the original list to currentList
		  currentList = this.state.getUserList
		  newList = currentList.filter((item) => {
			let obj={};//Somnath Task-3972, Add required comumn in search fields
			obj[`firstName`]=item.firstName;
			obj[`lastName`]=item.lastName;
			obj[`email`]=item.userName;
			obj[`role`]=item.role;
			// change current item to lowercase
			const lc = obj;
			//const lc = item.toLowerCase();
			// change search term to lowercase
			const filter = e.target.value.toLowerCase();
			var data = Object.values(lc);
			var dataFinal = data.toString();
			dataFinal = dataFinal.replace(",", " ");
			var dataToLower = dataFinal.toLowerCase();
			return dataToLower.includes(filter);
		  });
		}
	
		// Set the filtered state based on what our rules added to newList
		this.setState({
		  userDetailsSearch: [...newList],
		  tableSearchText: filterData,
		});
	}
// Anshul-5726: handle checkboxes
	 handleCheckboxChange = (e, record) => {
  const {
    filterStatus,
    activatedUsersCheckboxArray,
    deactivatedUsersCheckboxArray,
  } = this.state;
  const isChecked = e.target.checked;

  let arrayToUpdate =
    filterStatus === "activeUsers"
      ? activatedUsersCheckboxArray
      : deactivatedUsersCheckboxArray;

  const updatedArray = isChecked
    ? [...arrayToUpdate, record] // <-- store full record, not just ID
    : arrayToUpdate.filter((u) => u.userID !== record.userID);

  const newState =
    filterStatus === "activeUsers"
      ? { activatedUsersCheckboxArray: updatedArray }
      : { deactivatedUsersCheckboxArray: updatedArray };

  this.setState(newState);
};


// Anshul-5726: fetchs all advertisers
  handleMoveButtonClick() {
 document.body.style.overflow = 'hidden';
	fetch("/users/getUsersToSwitchTeam", {
	  method: "POST",
	  headers: { "Content-Type": "application/json" },
	})
	  .then((res) => res.json())
	  .then((advertiserList) => {
		this.setState({ advertiserList });
	  })
	  .catch(function (err) {
		console.log("Error fetching Advertiser list:", err);
	  });

	this.setState({
	  showAdvertiserMovePopup: true,
	});
  } // end fetch all advertiser list

  handleClosePopup() {
    this.setState({
       showAdvertiserMovePopup: false,//Anshul-5726: move
    });
  }

//   Anshul-5726: added for updating users orgID

 handleMoveAdvertiserButton = () => {
  const {
	selectedAdvertiser,
	activatedUsersCheckboxArray,
	deactivatedUsersCheckboxArray,
  } = this.state;

  if (!selectedAdvertiser || selectedAdvertiser.length === 0) {
	Swal.fire({
	  text: "Please select a Advertiser to move",
	  type: "warning",
	  confirmButtonText: "Ok",
	});
	return;
  }

const { getUserList } = this.state;

 let selectedUserIDs = [];
if (activatedUsersCheckboxArray.length > 0) {
  selectedUserIDs = activatedUsersCheckboxArray.map(u => u.userID);
} else if (deactivatedUsersCheckboxArray.length > 0) {
  selectedUserIDs = deactivatedUsersCheckboxArray.map(u => u.userID);
}
 else {
	Swal.fire({
	text: "No users selected to move",
	type: "warning",
	confirmButtonText: "Ok",
  });
  return;
}

const selectedUsers = getUserList.filter(user =>
  selectedUserIDs.includes(user.userID)
);

  const moveToUsers = selectedAdvertiser.map((adv) => ({
    moveToUserID: adv.advertiserID,
    moveToUserName: adv.advertiserName,
    moveToEmail:adv.email,
  }));

	  fetch("/users/updateUserOrgID", {
	  method: "POST",
	  headers: { "Content-Type": "application/json" },
	  body: JSON.stringify({
		users: selectedUsers,
		moveToUsers,
	  }),
	})
		.then((res) => res.json())
		.then((response) => {
		  if (response.success === true) {
			Swal.fire({
			  text: "Users Updated Successfully",
			  type: "success",
			  confirmButtonText: "Ok",
			  allowOutsideClick: false,
			  preConfirm: () => {
				window.location.reload();
			  },
			});
		  } else {
			Swal.fire({
			  text: "Users Not Updated",
			  type: "error",
			  confirmButtonText: "Ok",
			  allowOutsideClick: false,
			});
		  }
	
		  this.setState({ showAdvertiserMovePopup: false });
		})
		.catch((error) => {
		  console.error("Error in Update request:", error);
		});
	};
  


	render() {
		const asterisk = { color: "red" };

		  const { getUserList, userDetailsSearch, tableSearchText, filterStatus } =
      this.state;

    let filteredData = tableSearchText === "" ? getUserList : userDetailsSearch;

    filteredData = filteredData?.filter((user) => {
      const isActive =
        user.status === "Y" || user.status === null || user.status === "";
      return filterStatus === "activeUsers" ? isActive : !isActive;
    });

		//Sandeep-task-3447-added table to get user details
		const addUserAdvertiser = [
			   // Anshul-5726: added checkboxes
				{
			  title: "",
			  dataIndex: "",
			  key: "checkbox",
			  width: 30,
			  align: "center",
			  render: (text, record) => {
				const isUserAlreadyActive = this.state.getUserList.some(
				  (u) =>
					u.userName === record.userName &&
					u.role === record.role &&
					(u.status === "Y" || u.status === null || u.status === "")
				);
			
				const isDeactivatedView = this.state.filterStatus === "deactivatedUsers";
				const shouldDisableCheckbox = isUserAlreadyActive && isDeactivatedView;
			
			const isChecked =
  this.state.filterStatus === "activeUsers"
    ? this.state.activatedUsersCheckboxArray.some((u) => u.userID === record.userID)
    : this.state.deactivatedUsersCheckboxArray.some((u) => u.userID === record.userID);

			
				const checkbox = (
				  <input
					type="checkbox"
					checked={isChecked}
					disabled={shouldDisableCheckbox}
					onChange={(e) =>
					  !shouldDisableCheckbox && this.handleCheckboxChange(e, record)
					}
					style={{
					  width: "20px",
					  height: "20px",
					  cursor: shouldDisableCheckbox ? "not-allowed" : "pointer",
					  accentColor: "#0A61AD",
					}}
				  />
				);
			
				return (
				  <div>
					{shouldDisableCheckbox ? (
					  <Tooltip title="User is already active with this role">
						<span>{checkbox}</span>
					  </Tooltip>
					) : (
					  checkbox
					)}
				  </div>
				);
			  },
			},//Anshul-5726: end checkbox
			{
				title: "ID",
				dataIndex: "ID",
				key: "ID",
				width: 60,
				align: "Center",
				render: (text, record) => (
					<div>
						<span style={{ fontSize: "14px" }}>{record.userID}</span>
					</div>
				),
			},
			{
				title: "First Name",
				dataIndex: "firstName",
				key: "firstName",
				width: 100,
				align: "Center",
				render: (text, record) => (
					<div>
						<div style={{ fontSize: "14px", width: "110px" }}>
							{record.firstName}
						</div>
					</div>
				),
			},
			{
				title: "Last Name",
				dataIndex: "lastName",
				key: "lastName",
				width: 100,
				align: "Center",
				render: (text, record) => (
					<div>
						<div class="word-wrap" style={{ fontSize: "14px" }}>
							{record.lastName}
						</div>
					</div>
				),
			},
			{
				title: "Email",
				dataIndex: "email",
				key: "email",
				width: 180,
				align: "Center",
				render: (text, record) => (
					<div>
						<span style={{ fontSize: "14px" }}>{record.userName}</span>
					</div>
				),
			},
			{
				title: "Role",
				dataIndex: "role",
				key: "role",
				width: 45,
				align: "Center",
				render: (text, record) => (
					<div>
						<span style={{ fontSize: "14px" }}>{record.role}</span>
					</div>
				),
			},
			//Rutuja -5101 added action and status column 
			// {
			// 	title: "Status",
			// 	dataIndex: "status",
			// 	key: "status",
			// 	width: 55,
			// 	align: "Center",
			// 	render: (text, record) => (
			// 	  <div>
			// 		{record.status === "N" ? (
			// 		  <span style={{ fontSize: "14px" }}>Deactivated</span>
			// 		) : (
			// 		  <span style={{ fontSize: "14px" }}>Active</span>
			// 		)}
			// 	  </div>
			// 	),
			//   },

			// Anshul-5726: updated status column added text color
			 {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 40,
        align: "center",
        render: (text, record) => (
          <div>
            <span
              style={{
                fontSize: "13px", //Anshul-5780: changed width
                fontWeight: "bold",
                color: record.status === "N" ? "red" : "green",
              }}
            >
              {record.status === "N" ? "Deactivated" : "Active"}
            </span>
          </div>
        ),
      },
	//   Anshul-5726: removed action column 
			// {
			// 	title: "Action",
			// 	dataIndex: "Action",
			// 	key: "Action",
			// 	width: 40,
			// 	align: "Center",
			// 	render: (text, record) => (
			// 	  <div>
			// 		{record.status === "Y" ||
			// 		record.status === null ||
			// 		record.status === "" ? (
			// 		  <button
			// 			style={{ padding: "7px 7px", margin: "auto" }}
			// 			className={this.state.inputClass11}
			// 			onClick={(e) => this.changeUserStatusInactive(e, record)}
			// 			type="submit"
			// 		  >
			// 			Deactive{" "}
			// 		  </button>
			// 		) : (
			// 		  <button
			// 			style={{ padding: "7px 7px", margin: "auto" }}
			// 			className={this.state.inputClass11}
			// 			onClick={(e) => this.changeUserStatusActive(e, record)}
			// 			type="submit"
			// 		  >
			// 			Activate{" "}
			// 		  </button>
			// 		)}
			// </div>
			// 	),
			// },
		];
return (
			<div>
				<Navigation />
				<div class="container-fluid" style={{ paddingTop: "100px" }}>
				<div class="row">{/*mufiz-task-397 add new back button*/}
                       <div class="col-lg-4" style={{paddingLeft:'20px'}}>
						{/* Anshul-5780: added tooltip for back button */}
                       <a href="./advertiserDashboard"  style={{color: '#056eb8'}}><FaArrowAltCircleLeft size={32} style={{float:'left'}} title="Back to Dashboard"/></a>
                       </div>
					   </div>
					   {/* Anshul-5726: changed title fo the page */}
					   {/* Anshul-5780: changed title of page */}
					   <h2 align="center" id="labelDI" style={{marginTop:"-31px"}} >Add/Manage Users</h2>
					   {/* Umesh-4254-R28.8-Prod issue-Advertiser login-setting option-Add User main Page issue */}
					   <div
								 class="card-body"
								 className="cardBodyClass advertiserBodyClass"
								 style={{
								   margin: "10px",
								   backgroundColor: "#fff",
								   borderRadius: "4px",
								   boxShadow: "grey 1px 1px 6px 0px", //mufiz-task-3975 styling a box
								 }}
							   >
								 {/* <legend className="legend labelsubheading">User Details</legend> */}
								 {/* //shivani-3284-passed ID for DI label consistency */}
								 {/*Anshul-5726: commented below div */}
								 {/* <div class="col-12" style={{ textAlign: "center" }}></div> 
					 
								 <div style={{ fontSize: "14px", color: "red" }}>
								   {this.state.errors.commonError}
								 </div>
								 <div
								   className="errorMsg"
								   style={{ fontSize: "14px", color: "red" }}
								 >
								   {this.state.errors.userName}
								   {this.state.errors.role}
								   {this.state.errors.firstName}
								   {this.state.errors.lastName}
								   {this.state.errors.sameUser}
								 </div> */}
								 {/* <div class="row">  */}{" "}
								 {/* anshul-5726: added new div to show fields in one row */}
								 <div
								   className="user-input-container"
								   style={{
									 display: "flex",
									 gap: "75px",
									 alignItems: "flex-end",
									 flexWrap: "wrap",
								   }}
								 >
								   {" "}
								   {/* anshul-5726: added new div to combine all fields in one row */}
								   {/* <div class="col-xs-12 col-sm-12 col-md-2 col-lg-4" >
									  <label id="label">User Name <span style={asterisk}>*&nbsp; 
									  <Tooltip title=" User name should be Valid Email Id.">
									  <Icon type="question-circle-o" />
									</Tooltip></span></label>
									  <input
										value={this.state.userName}
										onChange={this.handleChange}
										type="text"
										id="userName"
										className="form-control"
										name="userName"
										style={{ width: "60%", height: "60%" }}
										required />
									</div> */}
								   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}{" "}
								   {/* anshul-5726 : commented above div and added new div */}
								   <div style={{ flex: 1 }}>
									 {" "}
									 {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
									 <label id="label">
									   User Name{" "}
									   <span style={asterisk}>
										 *&nbsp;
										 <Tooltip title=" User name should be Valid Email Id.">
										   <Icon
											 type="question-circle-o"
											 className="iconbackground"
										   />
										   {/*sunita-task-3818-added classname as per requirement for removing white patches */}
										 </Tooltip>
									   </span>
									 </label>
									 {/* <br /> */}
									 {/* Anshul-5726: removed react Input and added HTML input */}
								    {/* Kiran Dhainje-5778:Added the condtion for not accepect the space. Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting */}

									 <input
									   // addonAfter={this.state.userDomain} //sunita-task-3782-commented this attribute as want to enable the domain field.
									    value={this.state.userName}
                                         onChange={this.handleChange}
                                         onKeyDown={(e)=>{
                                          if(e.key===" ")e.preventDefault();
                                               }} 
									   type="text"
									   id="avdUserName" 
									   className="form-control"
									   name="userName"
									   style={{
										 width: "100%",
										 height: "60%",
										 borderRadius: "10px",
										 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
									   }} // Anshul-5726: changed width from 60% to 100%, removed padding
									   required
									 ></input>
								   </div>
								   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
								   {/* Anshul-5726: comment above div and added new with flex 1 */}
								   {/* </div> */}{" "}
								   {/* anshul-5726: commented div to show fields in one row */}
								   {/* <br /> */}
								   {/* end of 1st row */}
								   {/* <div class="row"> */}{" "}
								   {/* anshul-5726: commented div to show fields in one row */}
								   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}
								   <div style={{ flex: 1 }}>
									 {" "}
									 {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
									 <label id="label">
									   First Name <span style={asterisk}>*</span>
									 </label>
									 <input
									   value={this.state.firstName}
									   onChange={this.handleChange}
									   type="text"
									   id="firstName"
									   className="form-control"
									   name="firstName"
									   style={{
										 width: "100%",
										 height: "60%",
										 borderRadius: "10px",
										 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
									   }} // Anshul-5726: Set width to 100%, removed padding
									   required
									 />
								   </div>
								   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
								   <div style={{ flex: 1 }}>
									 {" "}
									 {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
									 <label id="label">
									   Last Name <span style={asterisk}>*</span>
									 </label>
									 <input
									   value={this.state.lastName}
									   onChange={this.handleChange}
									   type="text"
									   id="lastName"
									   className="form-control"
									   name="lastName"
									   style={{
										 width: "100%",
										 height: "60%",
										 borderRadius: "10px",
										 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
									   }} // Anshul-5726: Set width to 100%, removed padding
									   required
									 />
								   </div>
								   <div style={{ flex: 1 }}>
									 {" "}
									 {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
									 {/*sunita-task-3782-added classname as per requirement */}
									 <label id="label">
									   Role <span style={asterisk}>*</span>
									 </label>
									 <select
									   value={this.state.role}
									   onChange={this.handleChange}
									   type="text"
									   id="role"
									   className="form-control"
									   name="role"
									   style={{
										 width: "100%",
										 height: "60%",
										 borderRadius: "10px",
										 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
									   }}
									   required
									 >
									 <option value="None Selected" disabled selected>
										None Selected
									</option>
									<option value="ADV">advertiser</option>
									 </select>
								   </div>
								   <div style={{ flex: 1 }}>
									 {" "}
									 {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
									 <Tooltip
									   title={
										 this.state.disableSaveButton
										   ? "All fields marked with * are mandatory"
										   : ""
									   }
									 >
									   <span>
										 <button
										   style={{
											 width: "40%",
											 margin: "0px",
											 marginLeft: "50px",
											 borderRadius: "10px",
											 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
										   }}
										   className="btn add-button buttonSave"
										   onClick={this.submitUser}
										   type="submit"
										   disabled={this.state.disableSaveButton}
										 >
											{/* Anshul-5780: changed button label */}
										   Add
										 </button>
									   </span>
									 </Tooltip>
								   </div>
								 </div>
								 {/* </div> */}{" "}
								 {/* anshul-5726: commented div to show fields in one row */}
								 {/* end of 2nd row */}
								 {/* <br /> */} {/* Anshul-5726:*/}
								 {/* locale={this.state.loading1?locale:"No Data"} */}
								 {/* pagination={{ pageSize: this.state.pageSize1 }} */}
								 {/* Anshul-5721: added error message below input fields */}
								 <div class="col-12" style={{ textAlign: "center" }}></div>
								 <div style={{ fontSize: "14px", color: "red" }}>
								   {this.state.errors.commonError}
								 </div>
								 <div
								   className="errorMsg"
								   style={{ fontSize: "14px", color: "red", marginTop: "10px" }}
								 >
								   {this.state.errors.userName}
								   {this.state.errors.role}
								   {this.state.errors.firstName}
								   {this.state.errors.lastName}
								   {this.state.errors.sameUser}
								 </div>
							   </div>
					 
							   {/* end of card body */}
							 </div>
							 {/* end of container-fluid */}
							 {/* <div className="d-flex justify-content-end"> */}{" "}
							 {/*Anshul-5726: changed class to place radio buttons at right and search input at right  */}
							 <div className="d-flex justify-content-between align-items-center flex-wrap"
							   style={{ width: "100%" }}>
							   {/* Anshul-5726: added radio buttons for active users and deactivated users */}
							   <div style={{ marginLeft: "15px", marginTop: "15px" }}>
								 <Radio.Group
								   className="lead-radio"
								   value={this.state.filterStatus}
								   onChange={(e) => {
									 const selectedFilter = e.target.value;
									 this.setState({
									   filterStatus: selectedFilter,
									   activatedUsersCheckboxArray:
										 selectedFilter === "deactivatedUsers"
										   ? []
										   : this.state.activatedUsersCheckboxArray,
									   deactivatedUsersCheckboxArray:
										 selectedFilter === "activeUsers"
										   ? []
										   : this.state.deactivatedUsersCheckboxArray,
									 });
								   }}
								 >
								   {/* Anshul-5726: start move popup */}
								   {this.state.showAdvertiserMovePopup && (
									 <div
									   style={{
										 position: "fixed",
										 top: 0,
										 left: 0,
										 width: "100%",
										 height: "100%",
										 backgroundColor: "rgba(0, 0, 0, 0.5)",
										 zIndex: 9999,
										 display: "flex",
										 justifyContent: "center",
										 alignItems: "center",
									   }}
									 >
									   <div
										 onClick={(e) => e.stopPropagation()}
										 style={{
										   backgroundColor: "#fff",
										   padding: "20px",
										   borderRadius: "10px",
										   width: "700px",
										   maxHeight: "70vh",
										   overflowY: "auto",
										   boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
										 }}
									   >
										 <div
										   style={{ display: "flex", gap: "20px", margin: "30px" }}
										 >
										   {/* select advertiser dropdown */}
										   <div style={{ flex: 1 }}>
											 <label id="label">
											   Select Advertiser:<span style={asterisk}>*</span>
											 </label>
											 <Picky
											   value={this.state.selectedAdvertiser}
											   options={this.state.advertiserList || []}
											   onChange={(selected) =>
												 this.setState({ selectedAdvertiser: selected })
											   }
											   multiple={true}
											   dropdownHeight={250}
											   labelKey="advertiserName"
											   valueKey="advertiserID"
											 />
										   </div>
					 
										   <div
											 style={{
											   width: "1px",
											   height: "300px",
											   backgroundColor: "#bababa",
											 }}
										   ></div>
					 
										
										   <div style={{ flex: 1 }}>
											 <label id="label">Selected Advertiser:</label>
					 
											 {this.state.selectedAdvertiser.length === 0 ? (
											   <div style={{ marginTop: "10px", color: "#888" }}>
												 No Advertiser selected
											   </div>
											 ) : (
											   <ul style={{ marginTop: "10px" }}>
												 {this.state.selectedAdvertiser.map((a, index) => (
												   <li key={index}>{a.advertiserName}</li>
												 ))}
											   </ul>
											 )}
										   </div>
										 </div>
					 
										 {/* start move and cancel  button */}
										 <div
										   style={{
											 textAlign: "right",
											 paddingRight: "1%",
											 //   marginBottom: "-3%",
										   }}
										 >
										   <div
											 style={{
											   position: "relative",
											   display: "inline-block",
											 }}
										   >
											 <button
											   type="submit"
											   className="btn"
											   onClick={this.handleMoveAdvertiserButton}
											   style={{
												 backgroundImage:
												   "linear-gradient(to left, #0777cb, #103784)",
												 color: "white",
												 padding: "0px",
												 width: "100px",
												 height: "30px",
												 marginLeft: "10px",
												 borderRadius: "10px",
												 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
											   }}
											   disabled={this.state.selectedAdvertiser.length === 0}
											 >
											   Switch Team
											 </button>
										   </div>
					 
										   <button
											 className="btn"
											 type="submit"
											 onClick={this.handleClosePopup}
											 style={{
											   marginLeft: "10px",
											   backgroundColor: "red",
											   color: "white",
											   height: "30px",
											   width: "100px",
											   padding: "0px",
											   borderRadius: "10px",
											   boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
											 }}
										   >
											 Cancel
										   </button>
										 </div>
					 
										 {/* end move and cancel  button */}
									   </div>
									 </div> //main div
								   )}
					 
								   {/* Anshul-5726 end move popup */}
					 
								   {/* Anshul-5726: added radio buttons */}
					 
								   <Radio value="activeUsers" id="activeUsers">
									 Active Users
								   </Radio>
								   <Radio value="deactivatedUsers" id="deactivatedUsers">
									 Deactivated Users
								   </Radio>
								 </Radio.Group>
							   </div>
					 
							   {/* //Aman-5454-added input for serach*/}
					 
							   {/* <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2" style={{display:"flex", alignItems:"center"}}> */}
							   <div className="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 d-flex align-items-center">
								 {" "}
								 {/* Anshul-5726: */}
								 <Tooltip title="Find the user's by Email/First Name/Last Name or role.">
								   <Icon
									 type="question-circle-o"
									 className="iconbackground"
									 style={{ marginTop: "10px" }}
								   />
								 </Tooltip>
								 &nbsp;&nbsp;
								 <input
								   type="text"
								   id="search_advertiser_addUser"
								   className="form-control search_advertiser_addUser"
								   value={this.state.filterData}
								   onChange={this.handleChangeSearch}
								   placeholder="Search..."
								   title="Search"
								   style={{
									 backgroundImage: "url(searchIcon.png)",
									 backgroundPosition: "15px 6px",
									 backgroundSize: "15px 15px",
									 backgroundRepeat: "no-repeat",
									 height: "20px",
									 fontSize: "12px",
									 borderRadius: "25px", //Anshul-5726: Increases the border radius
									 border: "1px solid rgb(221, 221, 221)",
									 padding: "16px 20px 16px 34px",
									 margin: "15px",        // Anshul-5726: added margin for search input
									 boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
								   }}
								 />
							   </div>
							 </div>
							 <br></br>
							 <p>
							   {this.state.tableSearchText === "" ? (
								 <Table
								   {...this.state.tableState}
								   bordered
								   dataSource={filteredData}
								   rowKey="campID"
								   columns={addUserAdvertiser}
								  className={`${tableCSS} "ant-table-thead"`}ant-pagination ant-table-pagination
								   scroll={{ y: 250 }}
								 />
							   ) : (
								 <Table
								   {...this.state.tableState}
								   bordered
								   dataSource={filteredData}
								   rowKey="campID"
								   columns={addUserAdvertiser}
								   className={`${tableCSS} "ant-table-thead table-responsive"`}
								 
								 />
							   )}
							 </p>

							 {/* Anshul-5780: hides the switch team button for the deactivated users and changed the position of the buttons */}
						<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px",
    marginTop: "20px",
    marginRight: "20px",
  }}
>
  {this.state.filterStatus === "activeUsers" && (
    <button
      className="btn add-button buttonSave"
      type="submit"
      disabled={this.state.activatedUsersCheckboxArray.length === 0}
      onClick={this.handleMoveButtonClick}
      style={{
        width: "120px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    >
      Switch Team
    </button>
  )}

  {this.state.filterStatus === "deactivatedUsers" ? (
    <button
      className="btn add-button buttonSave"
      type="submit"
      disabled={this.state.deactivatedUsersCheckboxArray.length === 0}
      onClick={() => this.changeUserStatusActive()}
      style={{
        width: "120px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    >
      Activate
    </button>
  ) : (
    <button
      className="btn add-button buttonSave"
      type="submit"
      disabled={this.state.activatedUsersCheckboxArray.length === 0}
      onClick={() => this.changeUserStatusInactive()}
      style={{
        width: "120px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    >
      Deactivate
    </button>
  )}
</div>

							 <br></br>
							 <br></br>
							 <Footer />
						   </div>
						 );
					   } // end of render
					 } // end of class

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
AddUserAdvertiser.propTypes = {
	logoutUser: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
	auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(
	withRouter(AddUserAdvertiser)
);
